import { useEffect, useState } from 'react';
import type { } from '@mui/x-date-pickers/themeAugmentation';
import type { } from '@mui/x-charts/themeAugmentation';
import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import type { } from '@mui/x-tree-view/themeAugmentation';
import { UserData, getUser } from '../../../frontend/pages/getUserDB';
import { getAuth, reload } from 'firebase/auth';
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from '../../components/AppNavbar';
import Header from '../../components/Header';
import SideMenu from '../../components/SideMenu';
import AppTheme from '../../shared-theme/AppTheme';
import ActionAreaCard from '../../components/ActionAreaCard';

export default function Dashboard(props: { disableCustomTheme?: boolean }) {
  const auth = getAuth();
  const user = auth.currentUser;
  const [userDB, setUserDB] = useState<UserData>();

  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      setUserDB({ ...data, email: user?.email });
    }
    dataUser();
  }, []);

  useEffect(() => {
    const updateDB = async () => {
      try {
        await fetch("/update-user", {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user: userDB
          }),
        });
      } catch (err) {
        console.error('Erro ao atualizar dbsalepage:', err);
      }
    }
    if (userDB) {
      updateDB();
    }
  }, [userDB]);

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        <Box
          component="main"
          sx={(theme: any) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header />
            <ActionAreaCard />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}